const { REACT_APP_HOST_URL } = process.env;

export default class MarketplaceResource {

  static async getAll(url = '', page = 0, limit = 9) {
    const response =  await fetch(`${REACT_APP_HOST_URL}${url}?filters[offset]=${page * 9}&filters[limit]=${limit}`, {
      method: 'GET'
    })
    return response.json();
  }

  static async getById(url = '', id) {
    try {
      const response = await fetch(`${REACT_APP_HOST_URL}${url}/${id}`, {
        method: 'GET'
      })

      if (response.status !== 200) {
        throw new Error(response);
      }
      return response.json();
    } catch (e) {
      console.log(e.message);
    }
  }

  static async getProducts(url = '') {
    const response =  await fetch(`${REACT_APP_HOST_URL}${url}`, {
      method: 'GET'
    })
    return response.json();
  }

  static async postQuotation(url = '', data, templateId) {
    try {
      data.templateId = templateId;
      data.phone = {};
      data.phone && (data["phone"]['countryCode'] = data['phone.countryCode'] ? data['phone.countryCode'] : '93');
      data.phone && (data["phone"]['number'] = data['phone.number']);
      delete data['phone.number'];
      console.log(data);
      const response =  await fetch(`${REACT_APP_HOST_URL}${url}`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
      })

      if (response.status === 404) {
        throw new Error(response);
      }

      return response.json();

    } catch (e) {
      console.log(e.message);
    }

  }
}
